import type { ShiftBreak } from '@libs/data-access/queries'
import moment from 'moment'

import type { BreakRow } from '../../ShiftForm/components/BreakRowsContainer/BreakRowsContainer'

import { displayRules } from './displayRules'
import { getBreaksInfos } from './getBreaksInfos'

const defaultCases = (
  hasSnapPad,
  breakId,
  typeDuration,
  typeStart,
  typeEnd,
  breakAsReal,
  plannedDuration,
  shiftEventsSize,
  hasEmployeeModifyReal,
  shiftIsFinishedWithoutOut,
  padType
) => {
  if (!hasSnapPad || hasEmployeeModifyReal || shiftEventsSize === 0) {
    return {
      value: {
        id: breakId || null,
        plannedDuration: typeDuration,
        ...(typeStart
          ? {
              timeRange: [
                moment(typeStart).format('HH:mm'),
                moment(typeEnd).format('HH:mm')
              ]
            }
          : {})
      }
    }
  }
  if (!breakAsReal && (plannedDuration === 0 || shiftEventsSize < 1)) {
    return null
  }
  if (
    breakAsReal &&
    shiftEventsSize === 1 &&
    !shiftIsFinishedWithoutOut &&
    padType === 'break_event'
  ) {
    return null
  }
  return {
    value: {
      id: breakId || null,
      plannedDuration: typeDuration,
      ...(typeStart
        ? {
            timeRange: [
              moment(typeStart).format('HH:mm'),
              moment(typeEnd).format('HH:mm')
            ]
          }
        : {})
    }
  }
}

export const getBreaksForForm = (
  shiftBreaks: ShiftBreak[] | undefined,
  hasSnapPad: boolean,
  breakAsReal: boolean,
  shiftIsFinishedWithoutOut: boolean,
  hasEmployeeModifyReal: boolean,
  clockInEvent: boolean,
  isShiftUnvalidate: boolean,
  padType: string
) => {
  return shiftBreaks && shiftBreaks?.length > 0
    ? shiftBreaks.map((shiftBreak, index) => {
        const hasPlanned = typeof shiftBreak.planned_duration === 'number'
        const hasReal = typeof shiftBreak.real_duration === 'number'

        const needReal =
          hasEmployeeModifyReal ||
          (hasEmployeeModifyReal === false && breakAsReal && clockInEvent) ||
          isShiftUnvalidate ||
          (hasPlanned &&
            hasReal &&
            shiftBreak.planned_duration !== shiftBreak.real_duration)

        const {
          plannedDuration,
          typeStart,
          typeEnd,
          typeDuration,
          shiftEventsSize
        } = getBreaksInfos(shiftBreak, needReal ? 'real' : 'planned')

        const edgeCase = displayRules(
          shiftBreak?.id,
          breakAsReal,
          shiftEventsSize,
          plannedDuration ?? 0,
          shiftIsFinishedWithoutOut,
          typeStart ?? null,
          'real',
          index === 0,
          typeDuration,
          typeEnd ?? null,
          true,
          hasSnapPad
        )

        return edgeCase !== null
          ? (edgeCase as BreakRow[])
          : defaultCases(
              hasSnapPad,
              shiftBreak?.id,
              typeDuration,
              typeStart,
              typeEnd,
              breakAsReal,
              plannedDuration,
              shiftEventsSize,
              hasEmployeeModifyReal,
              shiftIsFinishedWithoutOut,
              padType
            )
      })
    : []
}
